module.exports = __webpack_public_path__ + "static/media/om.1798270b.svg";